import React from 'react';
import PropTypes from 'prop-types';
import { TextEditor, MobileModal } from '../../../Modules';
import Formsy from 'formsy-react';

const NotesEditMobile = ({
  closeHandler,
  commitUpdate,
  onChange,
  open,
  reset,
  value
}) =>
  <MobileModal open={open} onClose={closeHandler} inline>
    <MobileModal.Header>
      <div className='menu'>
        <a
          className='item'
          onClick={e => {
            reset();
            setTimeout(() => closeHandler(e), 0);
          }}
        >
          Cancel
        </a>
      </div>
      <div className='right menu'>
        <a className='item' onClick={commitUpdate.bind(null, closeHandler)}>
          Save
        </a>
      </div>
    </MobileModal.Header>
    <MobileModal.Content>
      <Formsy.Form onSubmit={commitUpdate.bind(null, closeHandler)}>
        <TextEditor
          value={value}
          onChange={onChange}
          placeholder='Enter notes or additional details'
        />
      </Formsy.Form>
    </MobileModal.Content>
  </MobileModal>;

NotesEditMobile.propTypes = {
  closeHandler: PropTypes.func.isRequired,
  commitUpdate: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  reset: PropTypes.func.isRequired,
  value: PropTypes.string
};

export default NotesEditMobile;



// WEBPACK FOOTER //
// ./webpack/components/Document/Sections/Notes/NotesEditMobile.js